import { IFormService } from "../../service/form/FormService";

export default class DeleteRowInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(qualifierId: number) {
    await this.formService.deleteRow(qualifierId);
  }
}
